import React from 'react'
import { Box, Divider, Link, Stack, Typography } from '@mui/material'

import { Icon } from '../../components'
import { FontWeight } from '../../components/theme-provider/typography.ts'
import { COMPANY_PHONES, CONTENT_WRAPPER_SX, HELP_EMAIL, PR_EMAIL } from '../../constants.ts'
import { useMobileSelect } from '@/hooks'

export const Footer = (): React.ReactElement => {
  const { isMobile } = useMobileSelect()

  return (
    <Box
      sx={{
        alignItems: 'start',
        width: '100%',
        pt: {
          xs: 4.25,
          lg: 8.25,
        },
        pb: 3,
        mt: isMobile ? 4 : 0,
        backgroundColor: 'background.footer',
        color: 'white.main',
        fontFamily: 'GtAmericaLcg',
      }}
    >
      <Box sx={CONTENT_WRAPPER_SX}>
        <Box mb={7}>
          <Icon name="CifraBankLightIcon" size="initial" />
        </Box>
        <Stack direction="column" gap={1} mb={4}>
          {COMPANY_PHONES.map((phone) => (
            <Link
              key={phone}
              variant="h4"
              href={`tel:${phone.replace(/\s/g, '')}`}
              color="inherit"
              fontFamily="inherit"
              fontWeight={FontWeight.Bold}
            >
              {phone}
            </Link>
          ))}
        </Stack>
        <Stack gap={1.5} direction="column">
          <Typography variant="body2">
            Адрес: 127006, Россия, г. Москва, ул. Каретный ряд, дом 5/10, строение 2
          </Typography>
          <Typography variant="body2">
            Служба поддержки:{' '}
            <Link variant="inherit" color="inherit" href={`mailto:${HELP_EMAIL}`}>
              {HELP_EMAIL}
            </Link>
          </Typography>
          <Typography variant="body2">
            Пресс-служба:{' '}
            <Link variant="inherit" color="inherit" href={`mailto:${PR_EMAIL}`}>
              {PR_EMAIL}
            </Link>
          </Typography>
        </Stack>
        <Divider sx={{ mt: 5, mb: 2.5, borderColor: '#6B7782' }} />
        <Typography variant="caption" sx={{ color: '#9798A0' }}>
          © 2024 Цифра банк (ООО «Цифра банк»)
        </Typography>
      </Box>
    </Box>
  )
}
